export default function HeroSection() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/61880059a09b5b06014771f4457b4ca2.jpg"
          alt="TUL d.o.o. hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 md:px-10 text-center">
        <span className="inline-block border border-white/40 text-white/80 text-xs font-medium tracking-widest uppercase px-4 py-1.5 rounded-full mb-8">
          iOS Development Experts
        </span>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-thin text-white leading-tight tracking-tight mb-6">
          Modern Applications<br />
          <span className="font-light">for the iOS Platform</span>
        </h1>

        <p className="text-white/70 text-base md:text-lg font-light max-w-2xl mx-auto leading-relaxed">
          TUL d.o.o. is a team of experts crafting premium iOS experiences — from robust VPN security to intelligent device optimisation tools.
        </p>

        {/* Scroll indicator */}
        <div className="mt-16 flex flex-col items-center gap-2 animate-bounce">
          <span className="text-white/40 text-xs tracking-widest uppercase">Scroll</span>
          <div className="w-px h-8 bg-white/30" />
        </div>
      </div>
    </section>
  );
}
